<kendo-formfield>
    <div class="k-form-field-checkbox-wrap" >
        
            <button type="button"  fxFlex="100" (click)="toogleValue()"  kendoButton>
            <kendo-icon *ngIf="isChecked()"  name="check" [themeColor]="'success'"></kendo-icon>
            <kendo-icon *ngIf="!isChecked()" name="plus" [themeColor]="'light'"></kendo-icon>
            <strong [ngClass]="isChecked() ? 'checked-item' : 'not-checked-item' ">{{caption | translate}}</strong>
        </button>

        <input kendoCheckBox [id]="formControlName" type="checkbox" [formControl]="control" class="hidden-checkbox"/>
        
    </div>
</kendo-formfield>
